<template>
  <div v-if="message"  class="alert alert-danger fade show fixed-alert" role="alert">
    {{message}}
  </div>




<keep-alive>
 <LoginPage v-if="mode==='login'" :reglogin="login" @switch="changeMode"></LoginPage>
</keep-alive>
  <keep-alive>
    <RegistrationPage :currentlogin="login" :reglogin="login"   v-if="mode==='registration'" @switch="changeMode"></RegistrationPage>
  </keep-alive>
</template>

<script>
import LoginPage from "@/LoginPage.vue";
import RegistrationPage from "@/RegistrationPage.vue";

export default {
  methods:{
    changeMode(mode,login,message=null){
this.mode=mode;
this.login=login;
this.message=message;
    }


  },


  data(){
    return {
      mode: 'login',login: '',
      message:null,
    }

  },

  beforeMount() {

    // eslint-disable-next-line no-undef
  if(typeof APP_ENV.INIT.mode!=='undefined'&&APP_ENV.INIT.mode==="registration")
  {
    this.mode="registration";

  }

  },


  name: "LoginOrReg",
  components: {RegistrationPage, LoginPage}
}
</script>

<style scoped>

</style>
